module.exports = __webpack_public_path__ + "img/student-testimonial-03.a4f3e326.jpg";